"use client";

import { useState } from "react";
import Link from "next/link";
import LeaderboardContents from "@/components/LeaderboardContents";

// A leaderboard "folder" tabbed to the right edge of the screen. On desktop the
// panel slides out on hover; on touch (where hover sticks and can't be undone)
// the handle is a toggle and a backdrop / ✕ closes it again.
export default function LeaderboardDrawer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Mobile backdrop — tap anywhere off the panel to close it. */}
      {open && (
        <div
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
          onClick={() => setOpen(false)}
          aria-hidden
        />
      )}

      <div
        className={`group fixed right-0 top-1/2 z-40 flex max-h-[88vh] -translate-y-1/2 items-stretch transition-transform duration-300 ease-out md:hover:translate-x-0 ${
          open ? "translate-x-0" : "translate-x-[calc(100%-2.75rem)]"
        }`}
      >
        {/* Handle — toggles the drawer on tap; on desktop hover also opens it. */}
        <button
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close leaderboard" : "Open leaderboard"}
          className="flex w-11 items-center justify-center rounded-l-2xl bg-accent shadow-[0_0_30px_rgba(124,58,237,0.5)]"
        >
          <span
            className="text-base font-extrabold uppercase tracking-[0.3em] text-white"
            style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
          >
            Leaderboard
          </span>
        </button>

        {/* Panel — slides into view on hover (desktop) or tap (mobile) */}
        <div className="flex w-[min(88vw,28rem)] flex-col overflow-hidden rounded-bl-2xl border-y border-l border-white/15 bg-background/95 shadow-[0_0_50px_rgba(0,0,0,0.7)] backdrop-blur">
          <div className="flex items-baseline justify-between gap-3 border-b border-white/10 px-5 py-4">
            <h3 className="text-lg font-extrabold uppercase tracking-widest text-white">
              Top Players
            </h3>
            <div className="flex shrink-0 items-baseline gap-3">
              <Link
                href="/leaderboard"
                className="text-xs font-bold uppercase tracking-widest text-accent hover:underline"
              >
                View all
              </Link>
              <button
                onClick={() => setOpen(false)}
                aria-label="Close leaderboard"
                className="text-lg leading-none text-white/50 transition hover:text-white md:hidden"
              >
                ✕
              </button>
            </div>
          </div>

          <LeaderboardContents maxEntries={10} />
        </div>
      </div>
    </>
  );
}
